import type { Schema } from '../types';

export const slot: Schema = {
  attributes: {
    primary: { type: String, required: true },
  },
};
